<template>
  <div class="sm-edit-notifications">
    <div class="sm-wrap">
      <div class="sm-edit-notifications__top">

      
        <div class="sm-edit-notifications__top-title">
          <a href="#" @click.prevent="$router.push('email-customers')">
            <include-svg :name="'icon-email-customers-sec'" />
          </a>
          <h2>Email customers</h2>
        </div>
        <div class="sm-edit-notifications__top-controls">
          <btn-block
            :type="'small'"
            :icon="'icon-add-mass-emails'"
            :text="'New email'"
            @click="openPopup('create')"
          />
        </div>
      </div>
      <div class="sm-edit-notifications__main">
        <table
          v-if="!isMobile"
          class="sm-table sm-edit-notifications__main-table"
        >
          <thead class="sm-table__head">
            <tr class="sm-txt-upper">
              <th class="sm-table__head-item id">ID</th>
              <th class="sm-table__head-item subject">Subject</th>
              <th class="sm-table__head-item email-body">Body</th>
              <th class="sm-table__head-item created sm-txt-center">
                Created at
              </th>
              <th class="sm-table__head-item visible-to sm-txt-center">
                Sent to
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="notif in notifications" :key="notif.id">
              <td class="id">{{ notif.id }}</td>
              <td class="subject">
                <text-truncate :text="notif.subject" />
              </td>
              <td class="body">{{ notif.body }}</td>
              <td class="created sm-txt-center sm-txt-nowrap">
                {{ notif.created_at | moment("D MMM, YYYY") }}
              </td>
              <td class="visible-to sm-txt-center">
                {{ checkVisibility(notif.group_type) }}
              </td>
            </tr>
          </tbody>
        </table>

        <div v-else class="sm-mobile-table sm-edit-notifications__main-mobile">
          <div class="sm-mobile-table-item header">
            <div class="sm-mobile-table-item-row">
              <div class="sm-mobile-table-item-row-th subject">Subject</div>
              <div class="sm-mobile-table-item-row-th visible-to sm-txt-center">
                Sent to
              </div>
            </div>
          </div>
          <div
            v-for="notif in notifications"
            :key="notif.id"
            class="sm-mobile-table-item"
            :class="notif.itemOpen ? 'open' : ''"
          >
            <div class="sm-mobile-table-item-row">
              <div
                class="sm-mobile-table-item-row-elem subject"
                @click="toggleItem(notif)"
              >
                <include-svg :name="'icon-arrow-b-bold'" />
                <span>{{ notif.subject }}</span>
              </div>
              <div
                class="sm-mobile-table-item-row-elem visible-to sm-txt-center"
              >
                {{ checkVisibility(notif.group_type) }}
              </div>
              
            </div>
            <ul class="sm-mobile-table-item-dropdown">
              <li>
                <span>ID</span>
                <span>{{ notif.id }}</span>
              </li>
              <li>
                <span>Created at</span>
                <span>{{ notif.created_at | moment("D MMM, YYYY") }}</span>
              </li>
              <li>
                <span>body</span>
                <span>{{ notif.body }}</span>
              </li>
            </ul>
          </div>
        </div>

        <btn-block
          v-if="canShowMore"
          :type="'show'"
          :text="'Show more'"
          :icon="'icon-arrow-round'"
          @click="showMore"
        />
      </div>
    </div>

    <keep-alive>
      <popup-block
        v-if="popup.isOpen"
        :open="popup.isOpen"
        :size="'large'"
        @close="popup.isOpen = false;"
      >
        <template slot="popupContent">
          <form-mass-emails
            v-if="popup.type == 'create'"
            :key="`form-mass-emails-${formKey}`"
            :groupTypes="groupTypes"
            @checkVisibility="checkVisibility"
            @submit="handleCreate"
          />
        </template>
      </popup-block>
    </keep-alive>

    <sm-spinner :show="showSpinner" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import HintWrap from "@/components/HintWrap";
import Popup from "@/components/Popup";
import Confirm from "@/components/Confirm";
import FormMassEmails from "@/components/forms/FormMassEmails";
import Spinner from "@/components/Spinner";
import vClickOutside from "v-click-outside";

export default {
  name: "edit-notifications",
  components: {
    "hint-wrap": HintWrap,
    "popup-block": Popup,
    "confirm-block": Confirm,
    "form-mass-emails": FormMassEmails,
    "sm-spinner": Spinner,
  },
  data() {
    return {
      popup: {
        isOpen: false,
        type: "", // values: create, edit, delete
        item: {},
      },
      showSpinner: false,
      notifications: [],
      formKey: 0,
      page: 1,
      totalPages: 0,
      groupTypes: [
        { value: "all_customers", name: "All" },
        { value: "active_customers", name: "Active " },
        { value: "inactive_customers", name: "Inactive " },
      ],
    };
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
      userAccount: "account/userAccount",
    }),
    canShowMore() {
      if (!this.notifs) return false;

      return this.notifs.total_pages > this.page;
    },
  },
  created() {
    this.showSpinner = true;
    this.getEmails({page: 1});
  },
  methods: {
    ...mapActions({
      getMassEmails: "getMassEmails",
      createMassEmail: "createMassEmail",
    }),
    getEmails(params) {
      this.getMassEmails(params).then((res) => {
        this.showSpinner = false;
        this.notifications = this.prepareNotifications([...res.records]);
        this.totalPages = res.pagination.total_pages;
        this.page = res.pagination.page;
      });
    },
    checkVisibility(value) {
      const groupType = this.groupTypes.find(
        (item) => item.value === value
      );
      return groupType.name + " customers";
    },
    prepareNotifications(arr) {
      return arr.map((item) => {
        return {
          ...item,
          itemOpen: false,
        };
      });
    },
    openPopup(type, item) {
      if (type != "create" || this.popup.type != "create") this.formKey++;

      this.popup.type = type;
      this.popup.item = item || {};
      this.popup.isOpen = true;
    },
    handleCreate(data) {
      this.formKey++;
      this.showSpinner = true;
      this.createMassEmail(data).then((res) => {
        this.popup.isOpen = false;
        this.popup.type = '';
        this.showSpinner = false;
        return this.getEmails({page: 1});
      });
    },
    toggleItem(item) {
      item.itemOpen = !item.itemOpen;
    },
    showItemPopup(item) {
      item.popupOpen = true;
    },
    hideItemPopup(item) {
      item.popupOpen = false;
    },
    showMore() {
      this.page++;
      this.showSpinner = true;
      this.getMassEmails({ page: this.page }).then((res) => {
        this.showSpinner = false;
        this.notifications = this.prepareNotifications([...this.notifications, res.records]);
        this.totalPages = res.pagination.total_pages;
        this.page = res.pagination.page;
      });
    },
  },
  watch: {
    userAccount: {
      deep: true,
      handler(val) {
        if (val.role && val.role != "manager") this.$router.push("/");
      },
    },
    notifs: {
      deep: true,
      handler(val) {
        if (val.notifications && val.notifications.length)
          this.notifications = this.prepareNotifications(val.notifications);
      },
    },
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
};
</script>

<style lang="scss">
@use "@/assets/scss/general/mixins.scss" as *;
@use "@/assets/scss/framework/scss-variables.scss" as *;
@use "@/assets/scss/pages/common/_edit-notifications.scss";
</style>